import { useEffect } from "react";

/**
 * V170.8 — Body scroll lock hook.
 *
 * When a modal / bottom-sheet is open, this locks scroll on <body> so the
 * background page doesn't drift under a finger drag on mobile, and so the
 * layout width doesn't shift when the scrollbar disappears on desktop.
 *
 * Stacking-safe: multiple simultaneous modals each ref-count the lock via a
 * data-attr counter. The <body> style is restored only when the last modal
 * releases it.
 *
 * Usage:  useBodyScrollLock(isOpen)
 */
export function useBodyScrollLock(active) {
    useEffect(() => {
        if (!active || typeof document === "undefined") return undefined;
        const body = document.body;
        const previousOverflow = body.style.overflow;
        const currentCount = parseInt(body.dataset.scrollLockCount || "0", 10);
        body.dataset.scrollLockCount = String(currentCount + 1);
        if (currentCount === 0) {
            body.style.overflow = "hidden";
        }
        return () => {
            const c = parseInt(body.dataset.scrollLockCount || "1", 10) - 1;
            if (c <= 0) {
                delete body.dataset.scrollLockCount;
                body.style.overflow = previousOverflow;
            } else {
                body.dataset.scrollLockCount = String(c);
            }
        };
    }, [active]);
}
